import { createAction } from "@reduxjs/toolkit";

export const createCardSuccess = createAction("cards/createCardSuccess")
export const cardRequest = createAction("cards/cardRequest")
export const updateCardSuccess = createAction("cards/updateCardSuccess")
export const photoRequest = createAction("cards/photoRequest")
export const photoSuccess = createAction("cards/photoSuccess")